/**
 * MonitorRenderingConstants
 */
export const MonitorRenderingConstants = {
    /**
     * The ID value to use for "no item" or when an object has been disposed.
     * @const {int}
     */
    ID_NONE: -1,


}